import React, { useState } from 'react';
import { post } from '../../utils/axiosUtils';

export default function ReviewComposer({ onSubmit }) {
  const [review, setReview] = useState('');

  const handleSubmit = async () => {
    if (!review.trim()) return;
    try {
      await post('/reviews', { content: review }); // replace URL later
      onSubmit({ author: 'You', content: review });
      setReview('');
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className='mt-6'>
      <textarea
        value={review}
        onChange={(e) => setReview(e.target.value)}
        placeholder='Write your feedback...'
        className='w-full p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500'
      />
      <button
        onClick={handleSubmit}
        className='mt-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-4 py-2 rounded-lg hover:opacity-90 transition'
      >
        Submit Review
      </button>
    </div>
  );
}
